import {ApolloLink, Observable} from '@apollo/client';

import type {InternalOperation} from '@sail/data';

export default function createV2LtmTelemetryLink() {
  return new ApolloLink((operation: InternalOperation, forward) => {
    return new Observable(function v2LtmTelemetryLinkSubscriptionFn(observer) {
      const context = operation.getContext();
      const observabilityFns = context.observabilityFns;
      const operationName = operation.operationName || 'unknown';

      const isTestUrl =
        typeof window !== 'undefined' &&
        window.location != null &&
        window.location.pathname.includes('/test/');

      const v2Context = (operation.variables || {}).v2Context;

      if (typeof v2Context === 'object' && v2Context !== null) {
        /* eslint-disable no-nested-ternary */
        const compartmentId =
          'compartmentId' in v2Context
            ? v2Context.compartmentId
            : 'compartment_id' in v2Context
            ? v2Context.compartment_id
            : 'id' in v2Context
            ? v2Context.id
            : undefined;
        /* eslint-enable */

        if (observabilityFns?.analytics?.action) {
          observabilityFns.analytics.action('v2_ltm_graphql', {
            operation_name: operationName,
            is_test_url: String(isTestUrl),
            compartment_id: compartmentId,
          });
        }
      }

      return forward(operation).subscribe({
        next: function handleNextFromLink(result) {
          observer.next(result);
        },

        error: function handleErrorFromLink(error: unknown) {
          observer.error(error);
        },

        complete: () => {
          observer.complete();
        },
      });
    });
  });
}
